import * as actionTypes from '../constants';

const initialState = {
  tokenType: '',
  accessToken: '',
  refreshToken: '',
  expiresIn: '',
  loggedIn: false,
  email: '',
  errorMessage: '',
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ACTION_UPDATE_AUTH:
      return { ...state, ...action.payload };
    case actionTypes.ACTION_INIT_AUTH:
      return initialState;
    default:
      return state;
  }
}
